import { Box, Divider, Typography } from '@mui/material';
import { isString } from 'lodash';
import moment from 'moment';
import React from 'react';
import KenTextLabel from '../KenTextLabel';
import KenIcon from '../KenIcon';
import ErrorIcon from '../../Assets/Icons/error.png';
import { makeStyles } from '@mui/styles';
import DoneIcon from '@mui/icons-material/Done';
import { DatePicker } from '@mui/x-date-pickers';
import KenError from '../KenError';

const useStyles = makeStyles({
  errorStyles: {
    backgroundColor: '#ffffff',
  },
  successMessage: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#158467',
  },
  dateField: {
    height: 'auto',
    width: '100%',
    borderRadius: '4px',
    backgroundColor: '#F3F5F7',
    color: '#000',
    fontSize: '16px',
    fontFamily: 'Poppins',
    border: 'none !important',
  },
});

const KenDateField = (props) => {
  const {
    label,
    required,
    optionalLabel,
    error,
    ui,
    success,
    hideLabel = false,
    helperText,
  } = props;
  const classes = useStyles();

  const maxDate =
    props?.maxDate &&
    props?.maxDate !== null &&
    (typeof props?.maxDate === 'string'
      ? moment(props?.maxDate)
      : props?.maxDate === true
      ? moment().format('YYYY-MM-DD')
      : props?.withValue
      ? moment(props?.otherDate)
          .add(
            Number(props?.maxDate),
            props?.dateType ? props?.dateType : 'year'
          )
          .format('YYYY-MM-DD')
      : moment()
          .add(
            Number(props?.maxDate),
            props?.dateType ? props?.dateType : 'year'
          )
          .format('YYYY-MM-DD'));

  const minDate =
    props?.minDate &&
    props?.minDate !== null &&
    (typeof props?.minDate === 'string'
      ? moment(props?.minDate)
      : props?.minDate === true
      ? moment().format('YYYY-MM-DD')
      : isString(props?.minDate)
      ? props?.minDate
      : props?.withValue
      ? moment(props?.otherDate)
          .subtract(
            Number(props?.minDate),
            props?.dateType ? props?.dateType : 'year'
          )
          .format('YYYY-MM-DD')
      : moment()
          .subtract(
            Number(props?.minDate),
            props?.dateType ? props?.dateType : 'year'
          )
          .format('YYYY-MM-DD'));

  return (
    <>
      <Box width="100%">
        {!hideLabel && (
          <KenTextLabel
            label={label}
            required={required}
            optionalLabel={optionalLabel}
            labelClassName={props.labelClassName}
            helperText={helperText}
          />
        )}
        <Box display="flex" alignItems="flex-start">
          <DatePicker
            className={classes.dateField}
            {...props}
            onChange={(e) => {
              const momentFormat = moment(e).format(
                props.format ? props.format : 'YYYY-MM-DD'
              );
              props.onChange(momentFormat);
            }}
            label={null}
            format={props?.format ? props?.format : 'YYYY-MM-DD'}
            maxDate={moment(maxDate) ? moment(new Date()) : ''}
            minDate={moment(minDate) ? moment(new Date(minDate)) : ''}
            value={props.value ? moment(props.value) : null}
          />
          {error && (
            <Box width="16px" height="16px" margin="19px 8px">
              <KenIcon
                iconType="img"
                icon={ErrorIcon}
                variant="extraSmall"
              ></KenIcon>
            </Box>
          )}
        </Box>
        {error && <KenError single={true} message={error} />}
        {success && (
          <Box display="flex" alignItems="flex-start" pt={1}>
            <Typography component="span">
              {success.icon || (
                <DoneIcon fontSize="small" style={{ color: '#158467' }} />
              )}
            </Typography>
            <Typography
              component="span"
              className={classes.successMessage}
              pl={1}
            >
              {success.message}
            </Typography>
          </Box>
        )}
      </Box>
      {ui && ui?.divider && (
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
      )}
    </>
  );
};

export default KenDateField;
